export const statesByCountry = {
    US: [
        { code: "AL", name: "Alabama" },
        { code: "AK", name: "Alaska" },
        { code: "AZ", name: "Arizona" },
        { code: "AR", name: "Arkansas" },
        { code: "CA", name: "California" },
        { code: "CO", name: "Colorado" },
        { code: "CT", name: "Connecticut" },
        { code: "DE", name: "Delaware" },
        { code: "FL", name: "Florida" },
        { code: "GA", name: "Georgia" },
        { code: "HI", name: "Hawaii" },
        { code: "ID", name: "Idaho" },
        { code: "IL", name: "Illinois" },
        { code: "IN", name: "Indiana" },
        { code: "IA", name: "Iowa" },
        { code: "KS", name: "Kansas" },
        { code: "KY", name: "Kentucky" },
        { code: "LA", name: "Louisiana" },
        { code: "ME", name: "Maine" },
        { code: "MD", name: "Maryland" },
        { code: "MA", name: "Massachusetts" },
        { code: "MI", name: "Michigan" },
        { code: "MN", name: "Minnesota" },
        { code: "MS", name: "Mississippi" },
        { code: "MO", name: "Missouri" },
        { code: "MT", name: "Montana" },
        { code: "NE", name: "Nebraska" },
        { code: "NV", name: "Nevada" },
        { code: "NH", name: "New Hampshire" },
        { code: "NJ", name: "New Jersey" },
        { code: "NM", name: "New Mexico" },
        { code: "NY", name: "New York" },
        { code: "NC", name: "North Carolina" },
        { code: "ND", name: "North Dakota" },
        { code: "OH", name: "Ohio" },
        { code: "OK", name: "Oklahoma" },
        { code: "OR", name: "Oregon" },
        { code: "PA", name: "Pennsylvania" },
        { code: "RI", name: "Rhode Island" },
        { code: "SC", name: "South Carolina" },
        { code: "SD", name: "South Dakota" },
        { code: "TN", name: "Tennessee" },
        { code: "TX", name: "Texas" },
        { code: "UT", name: "Utah" },
        { code: "VT", name: "Vermont" },
        { code: "VA", name: "Virginia" },
        { code: "WA", name: "Washington" },
        { code: "WV", name: "West Virginia" },
        { code: "WI", name: "Wisconsin" },
        { code: "WY", name: "Wyoming" },
    ],
    CA: [
        { code: "AB", name: "Alberta" },
        { code: "BC", name: "British Columbia" },
        { code: "MB", name: "Manitoba" },
        { code: "NB", name: "New Brunswick" },
        { code: "NL", name: "Newfoundland and Labrador" },
        { code: "NS", name: "Nova Scotia" },
        { code: "NT", name: "Northwest Territories" },
        { code: "NU", name: "Nunavut" },
        { code: "ON", name: "Ontario" },
        { code: "PE", name: "Prince Edward Island" },
        { code: "QC", name: "Quebec" },
        { code: "SK", name: "Saskatchewan" },
        { code: "YT", name: "Yukon" },
    ],
    GB: [
        { code: "ENG", name: "England" },
        { code: "SCT", name: "Scotland" },
        { code: "WLS", name: "Wales" },
        { code: "NIR", name: "Northern Ireland" }
    ],
    IE: [ // Ireland (counties)
        { code: "CW", name: "Carlow" },
        { code: "CN", name: "Cavan" },
        { code: "CE", name: "Clare" },
        { code: "CO", name: "Cork" },
        { code: "DL", name: "Donegal" },
        { code: "D", name: "Dublin" },
        { code: "GY", name: "Galway" },
        { code: "KY", name: "Kerry" },
        { code: "KE", name: "Kildare" },
        { code: "KK", name: "Kilkenny" },
        { code: "LS", name: "Laois" },
        { code: "LM", name: "Leitrim" },
        { code: "LK", name: "Limerick" },
        { code: "LD", name: "Longford" },
        { code: "LH", name: "Louth" },
        { code: "MO", name: "Mayo" },
        { code: "MH", name: "Meath" },
        { code: "MN", name: "Monaghan" },
        { code: "OY", name: "Offaly" },
        { code: "RN", name: "Roscommon" },
        { code: "SO", name: "Sligo" },
        { code: "TA", name: "Tipperary" },
        { code: "WD", name: "Waterford" },
        { code: "WH", name: "Westmeath" },
        { code: "WX", name: "Wexford" },
        { code: "WW", name: "Wicklow" }
    ],

    NZ: [ // New Zealand (regions)
        { code: "AUK", name: "Auckland" },
        { code: "BOP", name: "Bay of Plenty" },
        { code: "CAN", name: "Canterbury" },
        { code: "CIT", name: "Chatham Islands" },
        { code: "GIS", name: "Gisborne" },
        { code: "HKB", name: "Hawke's Bay" },
        { code: "MWT", name: "Manawatu-Wanganui" },
        { code: "MBH", name: "Marlborough" },
        { code: "NSN", name: "Nelson" },
        { code: "NTL", name: "Northland" },
        { code: "OTA", name: "Otago" },
        { code: "STL", name: "Southland" },
        { code: "TKI", name: "Taranaki" },
        { code: "TAS", name: "Tasman" },
        { code: "WKO", name: "Waikato" },
        { code: "WGN", name: "Wellington" },
        { code: "WTC", name: "West Coast" }
    ],

    AU: [ // Australia (states and territories)
        { code: "NSW", name: "New South Wales" },
        { code: "QLD", name: "Queensland" },
        { code: "SA", name: "South Australia" },
        { code: "TAS", name: "Tasmania" },
        { code: "VIC", name: "Victoria" },
        { code: "WA", name: "Western Australia" },
        { code: "ACT", name: "Australian Capital Territory" },
        { code: "NT", name: "Northern Territory" }
    ],
};